/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { DomainSwagger } from 'src/luis/core/services/domains/domainSwagger';
import { createDomainStore } from 'src/luis/core/stores/domainStore';
import { DomainStore } from 'src/luis/types/stores/domains/DomainStore';

/**
 * Creates an domain store from the api received
 * domain object.
 *
 * @param domain The domain object received from the api.
 * @returns An domain store.
 */
export const domainSwaggerToDomain = (domain: DomainSwagger): DomainStore => createDomainStore(domain);
